jQuery(function ($) {
    const initStoreLocator = function ($ele) {
        const $parentElement = $('.store-locator-list', $ele);
        const $provinceElement = $('.store-locator__search-province-select', $ele);
        const $districtElement = $('.store-locator__search-district-select', $ele);
        let provinceValue = '';
        $('select.store-locator__search-province-select', $ele).select2({
            language: langViSelect2,
             placeholder: "Chọn tỉnh/thành phố",
            allowClear: true
        });
        $('select.store-locator__search-district-select', $ele).select2({
            language: langViSelect2,
             placeholder: "Chọn quận/huyện",
            allowClear: true
        });
        const callbackProvinceSelect = (e) => {
            const data = e.params.data;
            const {id, text} = data;
            if (id == 0) {
                provinceValue = '';
                $parentElement.find('.location-by-province, .location-by-province ul, .location-by-province ul li').show();
            } else {
                provinceValue = text;
                $parentElement.find('.location-by-province, .location-by-province ul').not(`[data-province="${text}"]`).hide();
                $parentElement.find(`.location-by-province[data-province="${text}"], .location-by-province ul[data-province="${text}"]`).show();
            }
            $districtElement.empty();
            if (Object.hasOwn(window.DISTRICTS, id)) {
                window.DISTRICTS[id].forEach(function (district) {
                    $districtElement.append(`<option value="${district.code}">${district.name}</option>`);
                });
                $districtElement.val(null).trigger('change')
            }
        }
        const callbackDistrictSelect = (e) => {
            const data = e.params.data;
            const {id, text} = data;
            if (id == 0) {
              $parentElement.find(`[data-province="${provinceValue}"]`).show();
            } else {
              $parentElement.find(`.location-by-province ul[data-province="${provinceValue}"] > li[data-province="${provinceValue}"]`).not(`[data-district="${text}"]`).hide();
              $parentElement.find(`.location-by-province ul[data-province="${provinceValue}"] > li[data-province="${provinceValue}"][data-district="${text}"]`).show();
            }
        }
      const callbackProvinceClear = (e) => {
        provinceValue = '';
        $parentElement.find('.location-by-province, .location-by-province ul, .location-by-province ul li').show();
        $districtElement.val(null).trigger('change')
      }
      const callbackDistrictClear = (e) => {
         $parentElement.find(`[data-province="${provinceValue}"]`).show();
      }
        $provinceElement.off('select2:select', callbackProvinceSelect).on('select2:select', callbackProvinceSelect);
      $provinceElement.off('select2:unselect', callbackProvinceClear).on('select2:unselect', callbackProvinceClear);
        $districtElement.off('select2:select', callbackDistrictSelect).on('select2:select', callbackDistrictSelect);
      $districtElement.off('select2:unselect', callbackDistrictClear).on('select2:unselect', callbackDistrictClear);

      $provinceElement.val(null).trigger('change');
      
    }
    $('.store-locator-wrapper').each(function () {
        if ($(this).attr('initialized') == 1) return;
        initStoreLocator($(this));
        $(this).attr('initialized', 1);
    });
});
